'use strict';

var React = require('react');

var SvgTipsMajor = function SvgTipsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.5 0h-11c-.828 0-1.5.677-1.5 1.512v1.488h4.5a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-4.5v4.721a.2.2 0 0 0 .334.15l1.664-1.515a.497.497 0 0 1 .67 0l1.664 1.514c.19.173.48.173.67 0l1.663-1.514a.497.497 0 0 1 .67 0l1.663 1.514c.19.173.48.173.67 0l1.664-1.514a.497.497 0 0 1 .67 0l1.664 1.515a.2.2 0 0 0 .334-.15v-18.209c0-.835-.672-1.512-1.5-1.512zm-8.793 6.707a1 1 0 0 0-1.414-1.414l-6 6a1 1 0 1 0 1.414 1.414l6-6zm-6.207 1.293a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm6.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm8-8.5h-4v2h4v-2zm-4 4h4v2h-4v-2zm4 4h-4v2h4v-2z"
  }));
};

exports.SvgTipsMajor = SvgTipsMajor;
